import Moment from 'moment'
import { extendMoment } from 'moment-range'

const moment = extendMoment(Moment)

const dealerData = []

dealerData.push({
  id: 1,
  name: '北海道ブブ アウディ池袋',
})

dealerData.push({
  id: 2,
  name: '北海道ブブ アウディ足立',
})

const reservationData = []

reservationData.push({
  id: 1,
  liftId: 1,
  dealerId: 1,
  name: 'BMW M4',
  mechanic: '愛山',
  customer: '山田 太郎',
  classification: '法定点検',
  startAt: moment().hours(10).minutes(0).seconds(0).millisecond(0).toISOString(),
  endAt: moment().hours(13).minutes(0).seconds(0).millisecond(0).toISOString(),
})

reservationData.push({
  id: 2,
  liftId: 1,
  dealerId: 1,
  name: 'Audi 2.0TQ SL',
  mechanic: '橋下',
  customer: '鈴木 一郎',
  classification: '車検',
  startAt: moment().hours(14).minutes(0).seconds(0).millisecond(0).toISOString(),
  endAt: moment().hours(15).minutes(0).seconds(0).millisecond(0).toISOString(),
})

reservationData.push({
  id: 3,
  liftId: 2,
  dealerId: 1,
  name: 'Q5',
  mechanic: '林',
  customer: '佐々木 小次郎',
  classification: '修理',
  startAt: moment().hours(11).minutes(0).seconds(0).millisecond(0).toISOString(),
  endAt: moment().hours(15).minutes(0).seconds(0).millisecond(0).toISOString(),
})

reservationData.push({
  id: 4,
  liftId: 5,
  dealerId: 2,
  name: 'A6 Avant',
  mechanic: '林',
  customer: '田中',
  classification: '修理',
  startAt: moment().hours(10).minutes(30).seconds(0).millisecond(0).toISOString(),
  endAt: moment().hours(13).minutes(30).seconds(0).millisecond(0).toISOString(),
})

reservationData.push({
  id: 5,
  liftId: 4,
  dealerId: 2,
  name: 'A7 Sports',
  mechanic: '下村',
  customer: '高村',
  classification: '法定点検',
  startAt: moment().hours(10).minutes(30).seconds(0).millisecond(0).toISOString(),
  endAt: moment().hours(13).minutes(30).seconds(0).millisecond(0).toISOString(),
})

const liftData = []

liftData.push({
  id: 1,
  dealerId: 1,
  name: 'リフト1',
})

liftData.push({
  id: 2,
  dealerId: 1,
  name: 'リフト2',
})

liftData.push({
  id: 3,
  dealerId: 1,
  name: 'リフト3',
})

liftData.push({
  id: 4,
  dealerId: 2,
  name: 'リフトA',
})

liftData.push({
  id: 5,
  dealerId: 2,
  name: 'リフトB',
})

liftData.push({
  id: 6,
  dealerId: 2,
  name: 'リフトC',
})

export {dealerData, reservationData, liftData}



// WEBPACK FOOTER //
// ./src/mock.js